/* ==============================================================
   BBV custom JS — caricato da theme.liquid (defer)
   Step 4A · Load more AJAX collezioni (#bbv-loadmore)
   ============================================================== */

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('#bbv-loadmore');
  if (!btn) return;

  const nextUrl = btn.dataset.next;
  if (!nextUrl) return;

  if (btn.classList.contains('loading')) return;

  btn.disabled = true;
  btn.classList.add('loading');
  btn.setAttribute('aria-busy', 'true');

  try {
    const res = await fetch(nextUrl, { credentials: 'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // 1) Prendo la griglia corrente
    const grid = document.querySelector('#bbv-grid');
    if (!grid) throw new Error('bbv-grid non trovato nella pagina corrente');

    // 2) Prendo la griglia dalla pagina successiva (fallback incluso)
    const newGrid = doc.querySelector('.product-grid');


    if (!newGrid) throw new Error('Griglia non trovata nella pagina successiva');

    // 3) Estraggo gli item (solo elementi, niente wrapper)
    const newItems = Array.from(newGrid.children);

    if (!newItems.length) {
      // niente da appendere => probabilmente siamo alla fine oppure selector errato
      // ma almeno non lasciamo il bottone a vuoto
      const newBtn = doc.querySelector('#bbv-loadmore');
      if (!newBtn) btn.remove();
      throw new Error('Nessun nuovo item trovato da appendere');
    }

    // 4) Appendo in modo efficiente
    const frag = document.createDocumentFragment();
    newItems.forEach((el) => {
      // Symmetry/CleanCanvas: spesso i nuovi elementi restano "in animazione" e non si vedono.
      // Tolgo i marker di animazione per renderli subito visibili.
      el.removeAttribute('data-cc-animate');
      el.querySelectorAll('[data-cc-animate]').forEach(n => n.removeAttribute('data-cc-animate'));

      // Forzo visibilità base (non rompe layout)
      el.style.opacity = '1';
      el.style.transform = 'none';

      frag.appendChild(el);
    });
    grid.appendChild(frag);

    // Trigger naturale per lazyload/observer
    window.dispatchEvent(new Event('scroll'));

    // 5) Aggiorno next url (se c'è)
    const newBtn = doc.querySelector('#bbv-loadmore');
    if (newBtn && newBtn.dataset.next) {
      btn.dataset.next = newBtn.dataset.next;

      btn.disabled = false;
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');

      // Prefetch subito della prossima
      prefetchNext(btn.dataset.next);
    } else {
      btn.remove();
    }

  } catch (err) {
    console.error('Load more error:', err);
    btn.disabled = false;
    btn.classList.remove('loading');
    btn.removeAttribute('aria-busy');
  }
});

function prefetchNext(url) {
  if (!url) return;
  // evita duplicati
  if (document.querySelector(`link[rel="prefetch"][href="${url}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = url;
  link.as = 'document';
  document.head.appendChild(link);
}

// Prefetch coerente: al primo load + ogni volta che il bottone si rigenera (cambio filtri)
document.addEventListener('DOMContentLoaded', () => {
  const syncPrefetch = () => {
    const btn = document.querySelector('#bbv-loadmore');
    if (btn?.dataset?.next) prefetchNext(btn.dataset.next);
  };

  // Prefetch iniziale
  syncPrefetch();

  // Osserva il container della paginazione: quando il filter handler aggiorna
  // i prodotti via AJAX, il bottone viene rigenerato col data-next corretto.
  // Questo observer ricalibra il prefetch sul nuovo URL.
  const target = document.querySelector('#bbv-pagination') || document.body;
  new MutationObserver(syncPrefetch).observe(target, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-next']
  });
});



/* ==============================================================
   B2B "Opzione" → draft order (carrello + drawer)
   Clienti con tag B2B-MC2-OPZIONE: invia la selezione come
   richiesta non vincolante all'endpoint, poi svuota il carrello.
   Event delegation: robusto ai re-render AJAX del carrello.
   ============================================================== */
(function () {
  var ENDPOINT = 'https://hooks.bimbivip.com/api/opzioni-mc2';

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('#submit-opzione-b2b, #submit-opzione-b2b-drawer');
    if (!btn) return;
    e.preventDefault();

    var isDrawer = btn.id === 'submit-opzione-b2b-drawer';
    var feedback = document.getElementById(isDrawer ? 'opzione-feedback-drawer' : 'opzione-feedback');
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Invio in corso...';
    if (feedback) feedback.style.display = 'none';

    try {
      var cart = await (await fetch('/cart.js')).json();
      if (!cart.items || cart.item_count === 0) throw new Error('Il carrello è vuoto');

      var payload = {
        customer_id: btn.dataset.customerId,
        customer_email: btn.dataset.customerEmail,
        cart_note: cart.note || '',
        line_items: cart.items.map(function (item) {
          return {
            variant_id: item.variant_id,
            quantity: item.quantity,
            title: item.product_title,
            variant_title: item.variant_title,
            sku: item.sku || ''
          };
        })
      };

      var res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      var data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.error || 'Errore sconosciuto');

      await fetch('/cart/clear.js', { method: 'POST' });

      if (feedback) {
        feedback.style.background = '#e8f5e9';
        feedback.style.color = '#2e7d32';
        feedback.style.border = '1px solid #2e7d32';
        feedback.innerHTML = '✓ Richiesta inviata correttamente. Numero opzione: <strong>'
          + (data.draft_order_name || data.draft_order_id)
          + '</strong>. Ti contatteremo entro 24h.';
        feedback.style.display = 'block';
      }
      btn.style.display = 'none';
      setTimeout(function () { window.location.reload(); }, 4000);

    } catch (err) {
      console.error('Opzione B2B error:', err);
      if (feedback) {
        feedback.style.background = '#ffebee';
        feedback.style.color = '#c62828';
        feedback.style.border = '1px solid #c62828';
        feedback.textContent = 'Errore: ' + (err.message || err) + '. Riprova o contattaci.';
        feedback.style.display = 'block';
      }
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
})();
